<template>
  <div
    class="full-page checkout-container"
    :class="{ 'is-bnn': isBnn }"
  >
    <div
      v-if="$slots['summary-sticky']"
      class="section-summary-sticky"
    >
      <slot name="summary-sticky" />
    </div>

    <div class="left-container">
      <div class="section-information">
        <slot name="left-container" />
      </div>
    </div>

    <div class="right-container">
      <div class="section-summary dp-none dp-lg-flex">
        <slot name="right-container" />
      </div>
    </div>
  </div>
</template>

<script>
import isBnn from '@/config/isBnn'

export default {
  name: 'LayoutCheckout',

  data() {
    return {
      isBnn,
    }
  },
}
</script>

<style lang="stylus" scoped>

.checkout-container {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0 auto;

    @media screen and (min-width: 1024px) {
        display: grid;
        grid-template-columns: minmax(min-content, calc(50% + 72px)) 1fr;

        width: 100%;
        max-width: 100%;
        margin: 0;
    }

    > .left-container {
        width 100%
        max-width: 570px;
        background-color: #fff
        border-right: none;
        margin: 0 auto;
        min-height: 100dvh;

        @media screen and (min-width: 1024px) {
            max-width: 100%;
            border-right: 1px solid #dedede;
            margin: 0;
        }

        > .section-information {
            width 100%
            max-width: 100dvw
            padding: 21px 21px 0;
            display: flex;
            flex-direction: column;
            gap: 26px;

            @media screen and (min-width: 1024px)  {
                padding: 38px 22px 0;
                max-width: 660px;
                margin-left: auto;
            }
        }
    }

    >.right-container {
        width 100%
        background-color: #fff
        position: relative;


        @media screen and (min-width: 1024px) {
            width 100%
            background-color: $color-grey-light-80;
            min-height: 100dvh;
        }

        >.section-summary {
            width 100%
            max-width: 100dvw
            padding: 21px;

            display flex;
            flex-direction: column;
            gap: 32px;

            @media screen and (min-width: 1024px) {
                position: sticky;
                top: 72px;

                padding: 38px;
                width 100%
                max-width: 520px;
                margin-right: auto;

                display flex;
                flex-direction: column;
                gap: 24px;
            }
        }
    }
}

.checkout-container.is-bnn {
	background-color: $color-bnn-gray-light-2;

    > .left-container {
        background-color: $color-bnn-gray-light-2;
        border-right: none;
    }

    > .right-container {
        background-color: $color-bnn-gray-light-2;

		>.section-summary {
			padding: 38px 21px;
		}
    }
}

.section-summary-sticky {
    background-color: $color-grey-light-80;

    grid-column: span 2;

    ::v-deep .section-summary-sticky-accordion {
        width 100%
        max-width: 100dvw
        padding: 21px 21px 0;

        display flex;
        flex-direction: column;
        gap: 21px;
    }
}

.full-page
    overflow: visible !important
</style>
